/*
 * Copyright (c) 2020, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: MIT
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/MIT
 */

// This code is inspired by Polymer ShadyDOM Polyfill

import { getOuterHTML } from './outer-html';
import { isHostElement, getShadowRootFromHostElement } from './utils';
import { childNodesGetter } from '../env/node';
import { isSlotElement } from '../distortions/node';

function getChildNodesMarkup(childNodes: Node[] | NodeListOf<Node & Element>): string {
  let s = '';
  for (let i = 0, len = childNodes.length; i < len; i += 1) {
    s += getOuterHTML(childNodes[i]);
  }
  return s;
}

export function getInnerHTML(elm: Element): string {
  if (isSlotElement(elm)) {
    return getChildNodesMarkup(elm.assignedNodes({ flatten: true }));
  } else if (isHostElement(elm)) {
    return getChildNodesMarkup(childNodesGetter.call(getShadowRootFromHostElement(elm as HTMLElement)!));
  }
  return getChildNodesMarkup(childNodesGetter.call(elm));
}
